import Navbar from './components/Navbar';
import Home from './components/Home';
import About from './components/About';
import Skills from './components/Skills';
import Project from './components/Project';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
     <Navbar />
     <Home />
     <About />
     <Skills />
     <Project />
     <Contact />
     <Footer />
    </div>
  )
}

export default App;